import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { EventEmitter } from 'events';
import { DialogData } from 'src/app/entities/dialogData';
import { CategoryService } from 'src/app/services/category.service';
import { SharedService } from 'src/app/services/sharedService';
import { TaxPayerService } from 'src/app/services/taxPayer.service';
import { DialogCommunicator } from '../dialog-communicator';

@Component({
  selector: 'gov-add-hierarchy-dialog',
  templateUrl: './add-hierarchy-dialog.component.html',
  styleUrls: ['./add-hierarchy-dialog.component.css']
})
export class AddHierarchyDialogComponent extends DialogCommunicator implements OnInit {

  hierarchy = {}
  entity: string
  emitter: EventEmitter
  name: any
  code: any
  taxNames: any[]

  constructor(
    public dialogRef: MatDialogRef<AddHierarchyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, public sharedService: SharedService,
    public taxPayerService: TaxPayerService,
    public categoryService: CategoryService,
    public confirmationDialog: MatDialog) {
    super(dialogRef, sharedService)
    this.setConfirmationDialog(this.confirmationDialog)
    this.entity = data.toString()
  }

  ngOnInit() {
    this.hierarchy["class"] = this.entity;
    this.setEntity(this.hierarchy);
  }

  public objectComparisonFunction = function (option, value): boolean {
    if (value)
      return option === value;
    return false;
  }
}
